import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { skillSchema } from "./schema";
import { fetchSkillData } from "./read";
import { useUpdateSkill } from "../update/mutation";
import { useCreateSkill } from "../create/mutation";

export const useSkillForm = ({ skillId }) => {
  const form = useForm({
    resolver: zodResolver(skillSchema),
    defaultValues: {
      logo: "",
      name: "",
      id: "",
    },
  });

  const updateSkill = useUpdateSkill();
  const createSkill = useCreateSkill();

  const handleCreate = async (context) => {
    const item = context.values;
    await createSkill.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateSkill.mutateAsync({ skillId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchSkillData({ skillId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
